import FloatingTextEffect from '../../effects/FloatingTextEffect';
import Colors from '~/constants/Colors';

const HealRendering = {
  render: function (data, gameBoard, isCaverns) {
    const victimSprite = gameBoard.getAllPieceSprites()[data.victimId];
    if (!victimSprite) {
      return;
    }

    if (victimSprite.textQueue) {
      var effect = new FloatingTextEffect(data.potency.toString(), 15, 0x00ff00);
      victimSprite.textQueue.push(effect);
    }
  },
};
export default HealRendering;
